/**
 * @file index.tsx
 *
 * @fileoverview Renders the education icon.
 */
import React from 'react';
import { NetworkIcon } from '~/vcl/icons/Network';
import { GraduationCapIcon } from '~/vcl/icons/GraduationCap';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

interface EducationIconProps {
  title?: string;
  width?: string;
  height?: string;
  color?: string;
}
export const EducationIcon = ({
  title,
  width = '1em',
  height = '1em',
  color,
  ...props
}: EducationIconProps) => {
  const { RESUME } = useFrontendConfig();

  return (
    <>
      {RESUME.DISABLE_GRADUATION_ICON ? (
        <NetworkIcon
          title={title}
          width={width}
          height={height}
          color={color}
          {...props}
        />
      ) : (
        <GraduationCapIcon
          title={title}
          width={width}
          height={height}
          color={color}
          {...props}
        />
      )}
    </>
  );
};
export default EducationIcon;
